<template>
  <div
    :class="props.class"
    class="simple-layout"
  >
    <AsyncIpBlocked v-if="ipBlock" />
    <template v-else>
      <SimpleHeader ref="simpleHeaderRef" />
      <main
        class="simple-main"
      >
        <slot />
        <Footer />
      </main>
    </template>
  </div>
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  defineAsyncComponent,
  provide,
  ref,
  useI18n,
  useSeoMeta,
} from '#imports'
import { useUserInfo } from '@/store/userInfo'
import { hydrateOnVisible } from 'vue'
import SimpleHeader from '~/layouts/basic/SimpleHeader.vue'
import { OG_SITE_NAME } from '~/types/constants'
import { InjectionKey } from '~/types/enum'
import Footer from './basic/Footer.vue'

const props = defineProps<{ class?: string }>()

const AsyncIpBlocked = defineAsyncComponent({
  loader: () => import('@/components/IpBlocked.vue'),
  hydrate: hydrateOnVisible(),
})

const { t } = useI18n()

useSeoMeta({
  ogSiteName: OG_SITE_NAME,
  description: () => t('page-description'),
  ogType: 'website',
  ogDescription: () => t('page-description'),
})

const simpleHeaderRef = ref<InstanceType<typeof SimpleHeader>>()
const showLoginDialog = (callback?: () => void) => simpleHeaderRef.value?.showLogin(callback)

provide(InjectionKey.SHOW_LOGIN_DIALOG, showLoginDialog)
const ipBlock = computed(() => !!useUserInfo().ipBlock)

</script>

<style
  lang="less"
  scoped
>
@import '@/assets/styles/util.less';

.simple-layout {
  display: flex;
  flex-direction: column;
  min-height: var(--vh, 100vh);
}

.simple-main {
  height: calc(var(--vh, 100vh) - var(--header-height));
  display: flex;
  flex-direction: column;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    min-height: 50px;
    border-radius: 3px;
    background: rgba(144, 147, 153, 0.3);

    &:hover {
      background: rgba(144, 147, 153, 0.5);
    }
  }
}
</style>
